import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {MatTooltipModule} from '@angular/material/tooltip';
import {DxDataGridModule, DxTreeViewModule, DxListModule, DxContextMenuModule, DxTemplateModule, DxSelectBoxModule, DxLoadPanelModule, DxCheckBoxModule, DxValidatorModule, DxValidationSummaryModule, DxButtonModule, DxBulletModule, DxTextBoxModule, DxTabPanelModule, DxSwitchModule, DxTagBoxModule} from 'devextreme-angular';

import {PlaneacionRoutingModule} from './planeacion-routing.module';
import {ComponentesModule} from '@componentes/Componentes.module';

import {PreguntaComponent} from './pregunta/pregunta.component';
import {PreguntaFormComponent} from './pregunta/preguntaForm.component';
import { GlobalModule } from "../global/global.module";
import { ImportarPreguntasComponent } from './pregunta/layout/importarPreguntas.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PlantillaPreguntaComponent } from './plantillapregunta/plantillapregunta.component';
import { PeriodoEvaluacionComponent } from './periodoevaluacion/periodoevaluacion.component';
import { PeriodoEvaluacionFormComponent } from './periodoevaluacion/periodoevaluacionForm.component';
import { PreparacionEvaluacionComponent } from './preparacionevaluacion/preparacionevaluacion.component';
import { PipesModule } from '@pipes/Pipes.module';
import { MatTabsModule } from '@angular/material/tabs';
import { AsignacionEvaluacionComponent } from './asignacionevaluacion/asignacionevaluacion.component';
import { AsignacionEValuacionDetalleComponent } from './asignacionevaluacion/asignacionevaluaciondetalle.component';
import { AsignacionEvaluacionColaboradorComponent } from './asignacionevaluacion/asignacioncolaborador/asignacionevaluacioncolaborador.component';
import { AsignacionEvaluacionAlmunosComponent } from './asignacionevaluacion/asignacionalumnos/asignacionevaluacionalumno.component';
import { AsignacionEvaluacionAlmunosColaboradoresComponent } from './asignacionevaluacion/asignacionalumnos/seccion/asignacionevaluacionalumno_colaborador.component';
import { AsignacionEvaluacionAlmunosMateriasComponent } from './asignacionevaluacion/asignacionalumnos/seccion/asignacionevaluacionalumno_materia.component';
import { AsignacionEvaluacionAlumnosForms } from './asignacionevaluacion/asignacionalumnos/asignacionevaluacionalumnomateriaform.component';
import { PreparacionEvaluacionFormComponent } from './preparacionevaluacion/preparacionevaluacionForm.component';
import { PreparacionPreguntaOpcionalEvaluacionComponent } from './preparacionevaluacion/preparacionevaluaciopregunta/seccion/preparacionevaluacionpregunta_opcional.component';
import { PreparacionEvaluacionPreguntaGeneral } from './preparacionevaluacion/preparacionevaluaciopregunta/preparacionevaluaciopregunta.component';
import { PreparacionEvaluacionPreguntaObligatorio } from './preparacionevaluacion/preparacionevaluaciopregunta/seccion/preparacionevaluacionpregunta_obligatorio.component';
import { PlantillaPreguntaFormComponent } from './plantillapregunta/plantillapreguntaForm.component';
import { AsignacionEvaluacionPadresComponent } from './asignacionevaluacion/asignacionevaluacionpadres/asignacionevaluacionpadres.component';
import { AsignacionEvaluacionPadresMateriaComponent } from './asignacionevaluacion/asignacionevaluacionpadres/asignacionevaluacionpadresseccion/asignacionevaluacionpadres_materia.component';
import { AsignacionEvaluacionPadresColaboradorComponent } from './asignacionevaluacion/asignacionevaluacionpadres/asignacionevaluacionpadresseccion/asignacionevaluacionpadres_colaborador.component';
import { AsignacionEvaluacionTallerComponent } from './asignacionevaluacion/asignacionevaluaciontalleres/asignacionevaluaciontaller.component';
import { AsignacionEvaluacionTallerPadreComponent } from './asignacionevaluacion/asignacionevaluaciontalleres/asignacionevaluaciontalleresseccion/asignacionevaluaciontaller_padre.component';
import { AsignacionEvaluacionTallerAlumnoComponent } from './asignacionevaluacion/asignacionevaluaciontalleres/asignacionevaluaciontalleresseccion/asignacionevaluaciontaller_alumno.component';
import { AsignacionEvaluacionPadresFormComponent } from './asignacionevaluacion/asignacionevaluacionpadres/asignacionevaluacionpadresform.component';
import { EvaluacionPendientePrevisualizarComponent } from '../evaluacionpendiente/colaborador/previsualizar/previsualizar.component';
import { EvaluacionPendientePrevisualizarAlumnoComponent } from '../evaluacionpendiente/alumno/previsualizar/previsualizar_alumno.component';


@NgModule({
    declarations: [
        PreguntaComponent,
        PreguntaFormComponent,
        ImportarPreguntasComponent,
        PlantillaPreguntaComponent,
        PeriodoEvaluacionComponent,
        PeriodoEvaluacionFormComponent,
        PreparacionEvaluacionComponent,
        PreparacionEvaluacionFormComponent,
        PreparacionPreguntaOpcionalEvaluacionComponent,
        PreparacionEvaluacionPreguntaGeneral,
        PreparacionEvaluacionPreguntaObligatorio,
        AsignacionEvaluacionComponent,
        AsignacionEValuacionDetalleComponent,
        AsignacionEvaluacionColaboradorComponent,
        AsignacionEvaluacionAlmunosComponent,
        AsignacionEvaluacionAlmunosColaboradoresComponent,
        AsignacionEvaluacionAlmunosMateriasComponent,
        AsignacionEvaluacionAlumnosForms,
        PlantillaPreguntaFormComponent,
        AsignacionEvaluacionPadresComponent,
        AsignacionEvaluacionPadresMateriaComponent,
        AsignacionEvaluacionPadresColaboradorComponent,
        AsignacionEvaluacionPadresFormComponent,
        AsignacionEvaluacionTallerComponent,
        AsignacionEvaluacionTallerPadreComponent,
        AsignacionEvaluacionTallerAlumnoComponent,
        EvaluacionPendientePrevisualizarComponent,
        EvaluacionPendientePrevisualizarAlumnoComponent,
    ],
    entryComponents: [
        PreguntaFormComponent,
        ImportarPreguntasComponent,
        PeriodoEvaluacionFormComponent,
        PreparacionEvaluacionFormComponent,
        PreparacionPreguntaOpcionalEvaluacionComponent,
        PreparacionEvaluacionPreguntaGeneral,
        PreparacionEvaluacionPreguntaObligatorio,
        AsignacionEValuacionDetalleComponent,
        AsignacionEvaluacionColaboradorComponent,
        AsignacionEvaluacionAlmunosComponent,
        AsignacionEvaluacionAlmunosColaboradoresComponent,
        AsignacionEvaluacionAlmunosMateriasComponent,
        AsignacionEvaluacionAlumnosForms,
        PlantillaPreguntaFormComponent,
        AsignacionEvaluacionPadresComponent,
        AsignacionEvaluacionPadresMateriaComponent,
        AsignacionEvaluacionPadresColaboradorComponent,
        AsignacionEvaluacionPadresFormComponent,
        AsignacionEvaluacionTallerComponent,
        AsignacionEvaluacionTallerPadreComponent,
        AsignacionEvaluacionTallerAlumnoComponent,
        EvaluacionPendientePrevisualizarComponent,
        EvaluacionPendientePrevisualizarAlumnoComponent,
    ],
    imports: [
        CommonModule,
        ComponentesModule,
        TranslateModule,
        FormsModule,
        MatTooltipModule,
        MatTabsModule,
        DxDataGridModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxValidationSummaryModule,
        DxButtonModule,
        DxValidatorModule,
        DxBulletModule,
        DxTagBoxModule,
        DxLoadPanelModule,
        DxTreeViewModule,
        DxListModule,
        AngularSvgIconModule,
        DxContextMenuModule,
        DxTemplateModule,
        DxSwitchModule,
        DxTextBoxModule,
        PipesModule,
        PlaneacionRoutingModule,
        GlobalModule,
        DxTabPanelModule,
    ]
})
export class PlaneacionModule {}
